<div class="main-container">
  <div class="badge-container">
    <div
      data-aos="fade-right"
      data-aos-duration="1000"
      data-aos-offset="-100"
      data-aos-once="true"
      data-aos-delay="500"
      class="badge"
    >
      Improve access
    </div>
    <div
      data-aos="fade-right"
      data-aos-duration="1000"
      data-aos-offset="-100"
      data-aos-once="true"
      data-aos-delay="1000"
      class="badge"
    >
      Increase efficiencies
    </div>
    <div
      data-aos="fade-right"
      data-aos-duration="1000"
      data-aos-offset="-100"
      data-aos-once="true"
      data-aos-delay="1500"
      class="badge"
    >
      Save money
    </div>
  </div>
  <div
    class="video-container"
    data-aos="fade-up"
    data-aos-duration="1000"
    data-aos-offset="-100"
    data-aos-once="true"
  >
    <img
      class="laptop"
      src="/assets/img/static-pages/medigi/Vector.png"
      alt=""
    />
    <div class="video">
      <img src="/assets/img/static-pages/medigi/company_logos.gif" />
    </div>
  </div>
</div>
